<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericDataTable from '../../components/generic/GenericDataTable.vue'

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'isDisabled'],

  components: {
    Button,
    ResponsiveButton,
    GenericCustomAutocompleteV2,
    GenericDataTable
},
  data(){
    return {
      data: {},
      addDocumentDialogVisible: false,
      newDocument: {},
      config: {}
    }
  },
  validations(){
    return {
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.config = config.getConfiguration('VesselProtocol').finalCommercialInfo;
    if(this.isDisabled){
      this.config.fieldsets.commercialValues.documentsTable.enableInlineEdit = false;
      this.config.fieldsets.commercialValues.documentsTable.enableDelete = false;
    }
  },
  mounted(){
    this.loadData();
  },
  watch: {
    addDocumentDialogVisible(newValue){
      if(!newValue){
        this.newDocument = {}
      }
    },
    isDisabled(newValue){
      this.config.fieldsets.commercialValues.documentsTable.enableInlineEdit = !newValue;
      this.config.fieldsets.commercialValues.documentsTable.enableDelete = !newValue;
    }
  },
  methods: {
    loadData(){
      this.$store.dispatch("generic/setLoading", true);
      this.loadDocuments();
      Service.getVesselProtocolFinalCommercialInfo(this.vesselProtocolId, ({success, data, notFound, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(success && data){
          this.data = data;
        } else if(!notFound){
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    loadDocuments(){
      let filters = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      this.$refs.documentsTable[0].filterFromView(filters);

    },

    updateData(){
      this.data.idVesselProtocol = this.vesselProtocolId;
      this.$store.dispatch("generic/setLoading", true);

      if(this.data.id){
        Service.updateVesselProtocolFinalCommercialInfo(this.data, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);

          if(success){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      } else {
        Service.addVesselProtocolFinalCommercialInfo(this.data, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);

          if(success){
            this.loadData();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    addDocument(){
      this.$store.dispatch("generic/setLoading", true);
      this.newDocument.idVesselProtocolFinalCommercialInformation = this.data.id;
      Service.addVesselProtocolFinalCommercialDocument(this.newDocument, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);

          if(success){
            this.loadData();
            this.addDocumentDialogVisible = false;
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
    },
    updateDocumentsData({newData, data}){
      let sameData = Object.entries(data).every(([key, value]) => value === newData[key])
      if(!sameData) {
        Service.updateVesselProtocolFinalCommercialDocument(newData, response => {
          if(response.success){
            this.loadData();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        });
      }
    },
    onDeleteRecord(){
      this.loadData();
    },
    calculateValue(calculationType){
      this.$store.dispatch("generic/setLoading", true);
      Service.calculateVesselProtocolFCI({calculationType, data: this.data}, ({success, data, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(success){
          this.data = data;
        } else {
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    }
  },
}

</script>

<template>
  <main>
    <Dialog :header="$t('vesselProtocol.addDocument')" v-model:visible="addDocumentDialogVisible" :style="{width: '500px'}" :modal="true">
      <div class="grid">
          <template v-for="field in config.fieldsets.commercialValues.documentsTable.columns" :key="field.name">
            <div class="col-12" v-if="!field.formHide">
              <label :for="field.name" >{{ $t(field.label) }}</label>
              <InputText 
                v-if="field.type === 'string'"
                :id="field.name"
                type="text"
                v-model="newDocument[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <Calendar
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                v-if="field.type === 'date'"
                :id="field.name"
                v-model="newDocument[field.name]"
                class="w-full mt-1" />
              <InputNumber
                v-if="field.type === 'number'"
                :id="field.name"
                v-model="newDocument[field.name]"
                class="w-full p-inputtext-sm mt-1" />
              <InputNumber
                v-if="field.type == 'decimal'"
                mode="decimal" :maxFractionDigits="field.digits"
                :id="field.name"
                v-model="newDocument[field.name]"
                class="w-full p-inputtext-sm m-1" />
              <Textarea
                v-if="field.type === 'textarea'"
                v-model="newDocument[field.name]"
                class="w-full m-1 h-10rem" />
              <GenericCustomAutocompleteV2
                v-if="field.type === 'select'"
                v-model="newDocument[field.name]"
                :api="field.api"
                :format="field.format"
                class="w-full p-inputtext-sm mt-1"
                />
            </div>
          </template>
          <div class="col-12 text-right">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addDocumentDialogVisible = false" class="p-button-outlined p-button-sm" />
            <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addDocument" class="p-button-outlined p-button-sm ml-2" />
          </div>
      </div>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <Toolbar>
          <template #start>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="updateData" :disabled="!uiPermissions('vesselProtocolFCISaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolFCISaveButton').isHidden" />
          </template>
        </Toolbar>
      </div>
      <div v-for="fieldset in config.fieldsets" class="col-12" :key="fieldset">
        <Fieldset :legend="$t(fieldset.label)" class="h-100">
          <template v-if="fieldset.documentsTable">
            <div class="grid">
              <div class="col-12">
                <GenericDataTable :configuration="fieldset.documentsTable" ref="documentsTable" :onCellEditComplete="updateDocumentsData" @onDeleteRecord="onDeleteRecord"/>
              </div>
              <div class="col-12 text-center">
                <template v-for="button in fieldset.documentsTable.buttons" :key="button">
                  <Button :label="$t(button.label)" :icon="button.icon" @click="button.action(this)" class="mr-2" :disabled="!uiPermissions('vesselProtocolFCIAddDocumentButton').isEnabled || !data.idVesselProtocolCommercialInformation || isDisabled" v-if="!uiPermissions('vesselProtocolFCIAddDocumentButton').isHidden" />
                </template>
              </div>
            </div>
          </template>
          <div class="grid mt-5">
            <template v-for="field in fieldset.fields" :key="field">
              <div class="col-12 lg:col-6">
                <label v-tooltip="$t('vesselProtocol.' + field.label)" class="short-label">
                  {{ $t('vesselProtocol.' + field.label) }}
                </label>
                <label class="d-block" v-if="field.readOnly">
                  {{ (data[field.name] ?? '-') }}
                </label>
                <template v-else>
                  <Dropdown
                    v-if="field.type == 'dropdown'"
                    :options="field.options" 
                    v-model="data[field.name]"
                    class="w-full p-inputtext-sm m-1" />
                  <InputText 
                    v-if="field.type == 'text'"
                    v-model="data[field.name]"
                    type="text"
                    :readonly="field.readOnly"
                    class="w-full p-inputtext-sm m-1" />
                  <InputNumber
                    v-if="field.type == 'number'"
                    v-model="data[field.name]"
                    :readonly="field.readOnly"
                    class="w-full p-inputtext-sm m-1" />
                  <InputNumber
                    v-if="field.type == 'decimal'"
                    mode="decimal" :maxFractionDigits="field.digits"
                    v-model="data[field.name]"
                    :readonly="field.readOnly"
                    class="w-full p-inputtext-sm m-1" />
                  <Calendar 
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                    v-if="field.type == 'date'"
                    v-model="data[field.name]"
                    class="w-full p-inputtext-sm m-1" />
                </template>
              </div>
            </template>
          </div>
          <div class="grid">
            <div class="col-12 text-center">
              <template v-for="button in fieldset.buttons" :key="button">
                <Button :label="$t(button.label)" :icon="button.icon" @click="button.action(data, this)" class="mr-2" />
              </template>
            </div>
          </div>
        </Fieldset>
      </div>
      <div class="col-12">
        <label v-tooltip="$t('vesselProtocol.notes')" class="short-label">
          {{ $t('vesselProtocol.notes') }}
        </label>
        <Textarea
          v-model="data.notes"
          class="w-full m-1 h-10rem" />
      </div>
    </div>
  </main>
</template>

<style scoped>

.short-label {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.h-100 {
  height: 100%;
}

.d-block {
  display: block;
}
</style>